import { ITeamClassificationSettingsOptions, TeamAreasControl, TeamIterationsControl } from "Agile/Scripts/Admin/TeamClassificationSettings";
import { TeamField } from "Agile/Scripts/Admin/TeamField";
import "VSS/LoaderPlugins/Css!Agile/Admin/AdminHub";

import Controls = require("VSS/Controls");
import Navigation = require("VSS/Controls/Navigation");
import Navigation_Services = require("VSS/Navigation/Services");
import TFS_Host_TfsContext = require("Presentation/Scripts/TFS/TFS.Host.TfsContext");
import TeamSettings = require("Agile/Scripts/Admin/TeamSettings");
import Utils_Core = require("VSS/Utils/Core");

import WorkItemTemplatesControl = require("Agile/Scripts/Admin/WorkItemTemplatesControl");

var tfsContext = TFS_Host_TfsContext.TfsContext.getDefault();

class WorkControl extends Controls.BaseControl {
    public static enhancementTypeName: string = "tfs.agile.AdminWorkControl";

    private _teamSettingsControl: TeamSettings.TeamSettingsControl;
    private _teamIterationsControl: TeamIterationsControl;
    private _teamAreasControl: TeamAreasControl;
    private _teamFieldControl: TeamField;

    private _templatesControl: WorkItemTemplatesControl.WorkItemTemplatesControl;

    private ACTION_GENERAL = "general";

    public initialize() {
        super.initialize();

        var $element = this.getElement();

        var options = { teamSettings: this._options };

        this._teamSettingsControl = <TeamSettings.TeamSettingsControl>(
            Controls.Enhancement.enhance(TeamSettings.TeamSettingsControl, $(".team-settings-control", $element), options)
        );

        this._teamIterationsControl = <TeamIterationsControl>(
            Controls.Enhancement.enhance(TeamIterationsControl, $(".team-iterations-control", $element), <ITeamClassificationSettingsOptions>options)
        );

        var $teamAreasContainer = $(".team-areas-control", $element);
        if ($teamAreasContainer.length > 0) {
            this._teamAreasControl = <TeamAreasControl>(
                Controls.Enhancement.enhance(TeamAreasControl, $teamAreasContainer, <ITeamClassificationSettingsOptions>options)
            );
        }

        var $teamFieldContainer = $(".team-field-control", $element);
        if ($teamFieldContainer.length > 0) {
            this._teamFieldControl = TeamField.createIn($teamFieldContainer);
        }

        this._templatesControl = <WorkItemTemplatesControl.WorkItemTemplatesControl>(
            Controls.Enhancement.enhance(WorkItemTemplatesControl.WorkItemTemplatesControl, $(".templates-control", $element), <
                WorkItemTemplatesControl.IWorkItemTemplatesControlOptions
            >{ tfsContext: tfsContext })
        );

        this._attachNavigation();
        this._setupProcessNavUrl();
    }

    private _setupProcessNavUrl(): void {
        let url =
            tfsContext.getActionUrl(null, null, {
                area: "settings",
                project: ""
            }) + "/process";

        let processName = Utils_Core.parseJsonIsland($(document), ".team-admin-work .process-name").processName;
        let fragment: string = Navigation_Services.getHistoryService().getFragmentActionLink("workitemtypes", {
            "process-name": processName
        });

        $(".customize-process-link").attr("href", url + fragment);
        $(".customize-process-message").prop("hidden", false);
    }

    private _hideAllControls() {
        this._teamSettingsControl.hide();
        this._teamIterationsControl.hide();

        if (this._teamAreasControl) {
            this._teamAreasControl.hide();
        }

        if (this._teamFieldControl) {
            this._teamFieldControl.hide();
        }

        if (this._templatesControl) {
            this._templatesControl.hide();
        }
    }

    private _showTeamSettingsControl() {
        this._hideAllControls();
        this._teamSettingsControl.show();
    }

    private _showTeamAreasControl() {
        this._hideAllControls();
        this._teamAreasControl.show();
    }

    private _showTeamIterationsControl() {
        this._hideAllControls();
        this._teamIterationsControl.show();
    }

    private _showTeamFieldControl() {
        this._hideAllControls();
        this._teamFieldControl.show();
    }

    private _showTemplatesControl() {
        this._hideAllControls();
        this._templatesControl.show();
    }

    private _processNavigation(state: any): void {
        switch (state.action) {
            case TeamAreasControl.ACTION_AREAS:
                this._showTeamAreasControl();
                break;
            case TeamIterationsControl.ACTION_ITERATIONS:
                this._showTeamIterationsControl();
                break;
            case TeamField.ACTION_TEAMFIELD:
                this._showTeamFieldControl();
                break;
            case WorkItemTemplatesControl.WorkItemTemplatesControl.ACTION_TEMPLATES:
                this._showTemplatesControl();
                break;
            case this.ACTION_GENERAL:
            default:
                this._showTeamSettingsControl();
                break;
        }

        // This updates the selected pivot and applys the selected style
        var $pivotView = $(".work-admin-pivot");

        if ($pivotView.length > 0) {
            var pivotControl = <Navigation.PivotView>Controls.Enhancement.getInstance(Navigation.PivotView, $pivotView.eq(0));

            if (pivotControl) {
                pivotControl.setSelectedView(state.action);
            }
        }
    }

    private _actionGeneralNavigationHandler = (sender: any, state: any): void => {
        this._processNavigation(state);
    };

    private _actionAreasNavigationHandler = (sender: any, state: any): void => {
        this._processNavigation(state);
    };

    private _actionIterationsNavigationHandler = (sender: any, state: any): void => {
        this._processNavigation(state);
    };

    private _actionTeamFieldNavigationHandler = (sender: any, state: any): void => {
        this._processNavigation(state);
    };

    private _actionTemplatesNavigationHandler = (sender: any, state: any): void => {
        this._processNavigation(state);
    };

    private _attachNavigation() {
        /// <summary>attach the pivot views</summary>
        var historySvc = Navigation_Services.getHistoryService();
        historySvc.attachNavigate(this.ACTION_GENERAL, this._actionGeneralNavigationHandler, true);
        historySvc.attachNavigate(TeamAreasControl.ACTION_AREAS, this._actionAreasNavigationHandler, true);
        historySvc.attachNavigate(TeamIterationsControl.ACTION_ITERATIONS, this._actionIterationsNavigationHandler, true);
        historySvc.attachNavigate(TeamField.ACTION_TEAMFIELD, this._actionTeamFieldNavigationHandler, true);
        historySvc.attachNavigate(WorkItemTemplatesControl.WorkItemTemplatesControl.ACTION_TEMPLATES, this._actionTemplatesNavigationHandler, true);

        var state = historySvc.getCurrentState();
        // default selection
        if (!state.action) {
            this._showTeamSettingsControl();
        }
    }

    private _detachNavigation() {
        var historySvc = Navigation_Services.getHistoryService();
        historySvc.detachNavigate(this.ACTION_GENERAL, this._actionGeneralNavigationHandler);
        historySvc.detachNavigate(TeamAreasControl.ACTION_AREAS, this._actionAreasNavigationHandler);
        historySvc.detachNavigate(TeamIterationsControl.ACTION_ITERATIONS, this._actionIterationsNavigationHandler);
        historySvc.detachNavigate(TeamField.ACTION_TEAMFIELD, this._actionTeamFieldNavigationHandler);
        historySvc.detachNavigate(WorkItemTemplatesControl.WorkItemTemplatesControl.ACTION_TEMPLATES, this._actionTemplatesNavigationHandler);
    }

    public _dispose() {
        super._dispose();
        this._detachNavigation();
    }
}

Controls.Enhancement.registerEnhancement(WorkControl, ".team-admin-work");
